import React from 'react';
import { withStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import ORTypography from 'components/ORTypography/ORTypography';
import AddRegionFormContainer from 'components/AddRegionForm/AddRegionFormContainer';
import InstanceItemContainer from 'components/MissionCtrl/InstancesPage/InstanceItem/InstanceItemContainer';

const propTypes = {
  getAssociatedCockroachDBInstances: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  classes: PropTypes.shape({}).isRequired,
};

export function UnstyledRegionsTab({ getAssociatedCockroachDBInstances, id, classes, ...rest }) {
  const { catalog, service, metadata } = rest;
  const { multiInstanceId } = metadata;
  const associatedCockroachDBInstances = getAssociatedCockroachDBInstances(multiInstanceId, id);

  const maturity = (catalogProp, instanceService) =>
    catalogProp.servicesCatalog.services.find(
      (catalogService) => catalogService.name === instanceService,
    ).maturityLevel;

  const associatedCockroachDBInstancesItems = associatedCockroachDBInstances.map(
    (associatedCockroachDBInstance) => (
      <InstanceItemContainer
        {...associatedCockroachDBInstance}
        key={associatedCockroachDBInstance.id}
        classes={{ panel: classes.instanceItemContainer }}
        serviceMaturity={maturity(catalog, service)}
      />
    ),
  );

  return (
    <div className={classes.pageContainer}>
      <AddRegionFormContainer instanceId={id} metadata={metadata} {...rest} />
      <div className={classes.relatedBorder} />
      <div className={classes.relatedContentContainer}>
        <ORTypography>Related Instances</ORTypography>
        <ORTypography className={classes.relatedSectionHeader} component="h5">
          These instances are related through the same unique Group ID.
        </ORTypography>
        {associatedCockroachDBInstancesItems}
      </div>
    </div>
  );
}

UnstyledRegionsTab.propTypes = propTypes;

const styles = (theme) => ({
  pageContainer: {
    backgroundColor: theme.customColors.white,
    border: `1px solid ${theme.customColors.lightGrey}`,
  },
  relatedBorder: {
    borderBottom: `1px solid ${theme.customColors.mediumGrey}`,
    width: '100%',
    marginBottom: theme.spacing(1.5),
  },
  relatedContentContainer: {
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  relatedSectionHeader: {
    fontSize: 12,
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(1),
    color: theme.customColors.mediumGrey,
  },
  instanceItemContainer: {
    '&:last-child': {
      marginBottom: '0 !important',
    },
  },
});

export default withStyles(styles)(UnstyledRegionsTab);
